/* import __COLOCATED_TEMPLATE__ from './deliverables-list.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-deliverables-list';

class PostingDeliverableListComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get deliverablesListForDisplay() {
    const {
      deliverables,
      limit,
    } = this.args;

    if (!limit) {
      return deliverables;
    }

    return deliverables.slice(0, limit);
  }

  get deliverablesListOverflowCount() {
    const {
      deliverables,
      limit,
    } = this.args;

    if (!limit) {
      return 0;
    }

    return Math.max(0, deliverables.length - limit);
  }
}

export default PostingDeliverableListComponent;
